const MAX_PROCESSED_BYTES = 5 * 1024 * 1024

export function readOriginalPhoto(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('photoReadFailed'))
    reader.onload = () => {
      const content = reader.result
      const match = typeof content === 'string' && content.match(/^data:image\/([^;,]+);base64,/i)
      if (!match) {
        reject(new Error('photoReadFailed'))
        return
      }
      resolve({ content, type: match[1].toLowerCase() })
    }
    try {
      reader.readAsDataURL(file)
    } catch (error) {
      reject(new Error('photoReadFailed'))
    }
  })
}

export function readCompressedPhoto(file) {
  return new Promise((resolve, reject) => {
    let imageUrl
    try {
      imageUrl = URL.createObjectURL(file)
    } catch (error) {
      reject(new Error('photoReadFailed'))
      return
    }
    const img = new Image()
    img.onerror = () => {
      URL.revokeObjectURL(imageUrl)
      reject(new Error('photoReadFailed'))
    }
    img.onload = () => {
      URL.revokeObjectURL(imageUrl)
      try {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (!ctx || !img.width || !img.height) throw new Error('photoReadFailed')
        const scale = Math.min(1, 800 / img.width, 800 / img.height)
        canvas.width = Math.max(1, Math.round(img.width * scale))
        canvas.height = Math.max(1, Math.round(img.height * scale))
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        const content = canvas.toDataURL('image/jpeg', 0.7)
        if (!content.startsWith('data:image/jpeg;base64,')) throw new Error('photoReadFailed')
        const base64 = content.split(',')[1]
        const bytes = Math.floor(base64.length * 3 / 4)
        if (bytes > MAX_PROCESSED_BYTES) throw new Error('photoTooLarge')
        resolve({ content, type: 'jpeg' })
      } catch (error) {
        reject(error.message === 'photoTooLarge' ? error : new Error('photoReadFailed'))
      }
    }
    try {
      img.src = imageUrl
    } catch (error) {
      URL.revokeObjectURL(imageUrl)
      reject(new Error('photoReadFailed'))
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/photoUpload.js